export default __webpack_public_path__ + "static/bold-5d9e645fe566a6705a1d46943edf73bc.png";